import { AfterViewInit, Component, Inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef
} from '@angular/material/dialog';
import { MatRadioButton, MatRadioGroup } from "@angular/material/radio";
import { FormsModule } from "@angular/forms";
import { MatButton } from "@angular/material/button";

@Component({
  selector: 'athletes-confirm-delete-session',
  providers: [],
  styleUrls: ['./confirm-delete-session.scss'],
  standalone: true,
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatRadioGroup,
    MatRadioButton,
    TranslateModule,
    FormsModule,
    MatButton,
    MatDialogClose
  ],
  templateUrl: './confirm-delete-session.html'
})
export class ConfirmDeleteSessionFormComponent implements AfterViewInit {
    public color = '';
    public confirmText = '';
    public confirmActionText = '';
    public deleteOption = 0;
    constructor(
        public dialog: MatDialogRef<ConfirmDeleteSessionFormComponent>,
        private _translater: TranslateService,
        @Inject(MAT_DIALOG_DATA) private _data : any
    ) {
        if (_data && _data.color) {
            this.color = _data.color;
        } else {
            this.color = 'warn';
        }

        if (_data && _data.confirmText) {
            this.confirmText = _data.confirmText;
        } else {
            this.confirmText = 'AreYouSureDeleteWarning';
        }

        if (_data && _data.confirmActionText) {
            this.confirmActionText = _data.confirmActionText;
        } else {
            this.confirmActionText = 'Delete';
        }
    }

    public ngAfterViewInit() {
    }

    public onConfirmClicked(): void {
        this.confirm(this.deleteOption);
    }

    private confirm(option: number): void {
        this.dialog.close(option);
    }
}
